import React, { useState, useRef, useEffect } from "react";
import { Menu } from "lucide-react";

const PageHeader = ({ 
  title, 
  description, 
  rightSlot, 
  mobileDropdownContent,
  className = "" 
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`page-header ${className}`}>
      {/* Mobile Header */}
      <div className="flex items-center justify-between w-full md:hidden">
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-bold text-slate-900 truncate">{title}</h2>
          {description && (
            <p className="text-slate-600 text-sm truncate">{description}</p>
          )}
        </div>
        
        {/* Mobile Settings Dropdown */}
        {mobileDropdownContent && (
          <div className="relative ml-4" ref={dropdownRef}>
            <button
              className="h-10 w-10 p-0 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors border border-gray-300"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </button>
            
            {/* Mobile Dropdown Menu */}
            {isMobileMenuOpen && (
              <div className="absolute right-0 top-12 w-72 bg-white rounded-lg border border-gray-300 shadow-lg z-50">
                <div className="p-4 space-y-3">
                  {mobileDropdownContent}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Desktop Header */}
      <div className="hidden md:flex items-center justify-between w-full">
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-bold text-slate-900">{title}</h2>
          {description && (
            <p className="text-slate-600 text-sm">{description}</p>
          )}
        </div>
        <div className="flex items-center gap-2 ml-4">
          {rightSlot}
        </div>
      </div>
    </div>
  );
};

export default PageHeader; 